import React from 'react';
import { Link } from 'react-router-dom';

const CompaniesHome = () => {
  return (
    <div>
      <h1>Companies Home</h1>
      <Link to="/companieslist">
        <button>Go to Company List</button>
      </Link>
      <br />
      <Link to="/companiesadd">
        <button>Add a company</button>
      </Link>
      <br />
      <Link to="/companiesdelete">
        <button>Delete a company </button>
      </Link>
      <br />
      <Link to="/companiesupdate">
        <button>Update a company </button>
      </Link>
    </div>
  );
};

export default CompaniesHome;
